<template>
  <div
    class="tree-select-dropdown-selected"
    :class="{'notEmpty': leafNodes.length !== 0}"
  >
    <div class="tree-select-dropdown-selected__summary">
      {{ totalItemsText }}
    </div>
    <div class="tree-select-dropdown-selected__reset_all">
      <div
        v-show="showResetAll"
        class="tree-select-dropdown-reset-all"
        @click="$emit('resetAll')"
      >
        <div class="tree-select-dropdown-reset-all__cross">
          <MIcon
            :icon="iconCross"
          />
        </div>
        <div class="tree-select-dropdown-reset-all__text">
          {{ _getTr('reset_all') }}
        </div>
      </div>
    </div>
    <div class="tree-select-dropdown-selected__items">
      <TreeSelectDropdownSelectedItem
        v-for="item in leafNodes"
        :key="item.id"
        :readonly="readonly"
        :item="item"
        @removeItem="$emit('removeItem', item.id)"
      />
    </div>
    <div
      v-if="leafNodes.length === 0"
      class="notify-container"
    />
  </div>
</template>

<script>
  import TreeSelectDropdownSelectedItem from 'components/Inputs/Select/TreeSelect/TreeSelectDropdownSelectedItem.vue';
  import iconCross from 'assets/icons/cross.svg';
  import MIcon from 'components/Design/MIcon';

  export default {
    name: 'TreeSelectDropdownSelected',
    components: {TreeSelectDropdownSelectedItem, MIcon},
    props: {
      flatChoices: {
        type: Object,
        default: Object
      },
      selectedItems: {
        type: Array,
        default: Array
      },
      nodesParentMap: {
        type: Object,
        default: Object
      },
      selectedItemsText: {
        type: String,
        default: ''
      },
      leafNodes: {
        type: Array,
        default: Array
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        iconCross
      };
    },
    computed: {
      showResetAll () {
        return !this.readonly && this.leafNodes.length > 0;
      },
      totalItemsText () {
        return this.selectedItemsText.format(this.leafNodes.length);
      }
    }
  };
</script>

<style>
  .tree-select-dropdown-selected {
    overflow: hidden;

    width: 252px;
    height: 336px;

    &.notEmpty {
      overflow-x: hidden;
      overflow-y: auto;
    }

    & .m-notification__text {
      font-size: 12px;
    }

    & .m-notification__contents {
      padding: 10px;
    }
  }

  .tree-select-dropdown-selected__items {
    padding: 2px 12px;
  }

  .tree-select-dropdown-selected__items .tree-select-dropdown-selected-item {
    margin-top: 6px;
  }

  .tree-select-dropdown-selected__summary {
    font-size: 14px;
    font-weight: var(--medium-font-weight);

    color: var(--text-main-color);

    padding: 20px 12px 12px;
  }

  .tree-select-dropdown-selected__reset_all {
    padding: 0 12px;
  }

  .tree-select-dropdown-reset-all {
    color: var(--panel-text-color);

    cursor: pointer;

    display: flex;

    align-items: center;
  }

  .tree-select-dropdown-reset-all:hover {
    color: var(--secondary-text-color);
  }

  .tree-select-dropdown-reset-all__cross {
    height: 14px;
    margin-right: 4px;
  }

  .tree-select-dropdown-reset-all__cross svg {
    width: 14px;
    height: 14px;
  }

  .notify-container {
    width: 230px;
    height: 70px;

    margin-top: 220px;
    margin-left: 10px;
  }
</style>
